/*
 * @Author: Charles_W 18510126271@163.com
 * @Date: 2023-08-30 11:16:56
 * @LastEditors: Charles_W 18510126271@163.com
 * @LastEditTime: 2023-12-25 14:11:36
 * @FilePath: /course-app/src/request/api/student.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEcurrentDay
 */

/**
 * 学员模块接口列表
 */
import { get, post } from '../http'; // 导入http中创建的axios实例
export const student = {

    //获取教练信息-下拉列表 
    getStudentSelectList() {
        return get(`${process.env.VUE_APP_BASE_API}/student/selectList`);
    },
    // 获取学员当前任务信息
    getStudentTaskInfo(data) {
        return get(`${process.env.VUE_APP_BASE_API}/task/info/stu/${data.studentId}?currentDay=${data.currentDay}`);
    },
    // 获取学员评价
    getStudentEvaluate(data) {
        return get(`${process.env.VUE_APP_BASE_API}/coach/evaluate/date/${data.studentId}?currentDate=${data.currentDate}`);
    },
    // 获取课时学员我的页面
    getClassHours(studentId) {
        return get(`${process.env.VUE_APP_BASE_API}/train/report/getStudentClass/${studentId}`);
    },
    // 获取学员训练日期
    getStudentTrainDate(data) {
        return get(`${process.env.VUE_APP_BASE_API}/train/date/info/${data.studentId}?type=1&currentDate=${data.currentDate}`);
    },
    // 学生课时记录信息
    getStudentClassHoursInfo(data) {
        return post(`${process.env.VUE_APP_BASE_API}/train/report/stuRecordList`, data);
    },
    // 提交反馈信息

    postFeedBack(data) {
        return post(`${process.env.VUE_APP_BASE_API}/coach/evaluate/feedBack`, data);
    },
    // 获取是否有未读消息
    getNoReadMessage(id) {
        return get(`${process.env.VUE_APP_BASE_API}/coach/evaluate/getReadStatus/${id}`);
    },
    // 获取学员课时明细列表
    getStudentClassDetailList(data) {
        return post(`${process.env.VUE_APP_BASE_API}/student/class/hours/list`, data);
    },
}
